/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Tab from './Tab/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs"
  
}) {
let globalTabsValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'tabs',
format: fromHelpers.visibleTabs,
})
let tabsNumberOfTabsToShowValueData = fromData.useDataValue({ viewPath,
context: 'tabs',
path: 'number_of_tabs_to_show',
})
let aggregateData = fromAggregate.afterN(globalTabsValueData, tabsNumberOfTabsToShowValueData)
  return (<React.Fragment
>
<div
  data-testid="Tabs.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(aggregateData) && aggregateData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tab"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Tab(${item?.id ?? item?._id ?? index})`}
      >
<Tab
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Tab(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }